import React, { useState, useEffect, useCallback } from "react";
import {
  HeadHolder,
  SettingWrap,
} from "../components/atoms/Setting/Setting.styles";
import { MdKeyboardArrowRight } from "react-icons/md";
import EditProfile from "components/atoms/Setting/EditProfile";
import ChangePassword from "components/atoms/Setting/ChangePass";
import PrivacyTerms from "components/atoms/Setting/PrivacyTerms";
import userProfile from "assets/user-profile.png";
import Customization from "components/atoms/Setting/Customization";
import AppSettings from "components/atoms/Setting/AppSettings";
import SwitchToggle from "components/atoms/Menu/Menu/SwitchToggle";
import { useSelector } from "react-redux";
import boy from "assets/Header/boy.svg";

const Settings = () => {
  const [userData, setUserData] = useState(null);
  const userFromRedux = useSelector(state => state.business.user);
  const hasInitializedRef = React.useRef(false);
  const privacyData = [
    {
      title: "Privacy Policy",
      paras: [
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was ",
        },
        {
          para: "popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
      ],
    },
  ];
  const termsData = [
    {
      title: "Terms of use",
      paras: [
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was ",
        },
        {
          para: "popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
        {
          para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make ",
        },
      ],
    },
  ];
  const [activeTab, setActiveTab] = useState("Edit Profile");
  function handleActiveSideBar() {
    document.body.classList.toggle("activeSettingSideBar");
  }
  function closeSideBar() {
    if (document.body.classList.contains("activeSettingSideBar")) {
      document.body.classList.remove("activeSettingSideBar");
    }
  }
  const [isOn, setIsOn] = useState(false);
  const handleToggle = () => {
    setIsOn((prev) => !prev);
  };

  // Update user data when profile is updated (memoized to prevent re-renders)
  const handleProfileUpdate = useCallback((updatedUserData) => {
    setUserData(updatedUserData);
  }, []);

  // Initialize user data from Redux (only once on mount)
  useEffect(() => {
    if (userFromRedux && !hasInitializedRef.current) {
      setUserData(userFromRedux);
      hasInitializedRef.current = true;
    }
  }, [userFromRedux]);

  // Get display values with fallbacks
  const displayName = userData?.profile?.first_name && userData?.profile?.last_name
    ? `${userData.profile.first_name} ${userData.profile.last_name}`
    : "User";
  const displayEmail = userData?.email || "user@example.com";
  const displayPicture = userData?.profilePicture || userProfile;
  return (
    <>
      <HeadHolder>
        <button
          onClick={() => handleActiveSideBar()}
          type="button"
          className="nav-opener"
        >
          <span />
        </button>
        <h2>Settings</h2>
      </HeadHolder>
      <SettingWrap>
        <div className="left-content">
          <div className="profile-wrap">
            <div className="image-wrap">
              <img src={boy || displayPicture} alt="profile_img" />
            </div>
            <strong className="title">{displayName}</strong>
            <p>{displayEmail}</p>
          </div>
          <div className="tabs-wrap">
            <div
              className="tab"
              onClick={() => {
                setActiveTab("Edit Profile");
                closeSideBar();
              }}
            >
              <strong className={activeTab === "Edit Profile" ? "active" : ""}>
                Edit Profile
              </strong>
              <MdKeyboardArrowRight />
            </div>
            <div className="tab" onClick={handleToggle}>
              <strong>Notifications</strong>
              <SwitchToggle onChange={handleToggle} checked={isOn}/>
            </div>
            <div
              className="tab"
              onClick={() => {
                setActiveTab("Change Password");
                closeSideBar();
              }}
            >
              <strong
                className={activeTab === "Change Password" ? "active" : ""}
              >
                Change Password
              </strong>
              <MdKeyboardArrowRight />
            </div>
            <div
              className="tab"
              onClick={() => {
                setActiveTab("Privacy Policy");
                closeSideBar();
              }}
            >
              <strong
                className={activeTab === "Privacy Policy" ? "active" : ""}
              >
                Privacy Policy
              </strong>
              <MdKeyboardArrowRight />
            </div>
            <div
              className="tab"
              onClick={() => {
                setActiveTab("Terms of Use");
                closeSideBar();
              }}
            >
              <strong className={activeTab === "Terms of Use" ? "active" : ""}>
                Terms of Use
              </strong>
              <MdKeyboardArrowRight />
            </div>
            <div
              className="tab"
              onClick={() => {
                setActiveTab("App Settings");
                closeSideBar();
              }}
            >
              <strong className={activeTab === "App Settings" ? "active" : ""}>
                App Settings
              </strong>
              <MdKeyboardArrowRight />
            </div>
            <div
              className="tab"
              onClick={() => {
                setActiveTab("Customization");
                closeSideBar();
              }}
            >
              <strong className={activeTab === "Customization" ? "active" : ""}>
                Customization
              </strong>
              <MdKeyboardArrowRight />
            </div>
          </div>
        </div>
        <div className="right-content">
          {activeTab === "Edit Profile" && <EditProfile onProfileUpdate={handleProfileUpdate} />}
          {activeTab === "Change Password" && <ChangePassword />}
          {activeTab === "Privacy Policy" && (
            <PrivacyTerms data={privacyData} />
          )}
          {activeTab === "Terms of Use" && <PrivacyTerms data={termsData} />}
          {activeTab === "App Settings" && <AppSettings />}
          {activeTab === "Customization" && <Customization />}
        </div>
      </SettingWrap>
    </>
  );
};

export default Settings;
